import { authHeaders, invokeApi, postRequest } from "../components/network/apiclient";
import { gamesEndpoint } from "./endpoint";

export const fetchGames = (token, onSuccess, onError, search_value, lastId, gameType) =>
    invokeApi(postRequest(gamesEndpoint.searchPath(), authHeaders(token), { name: search_value, lastId, gameType }), onSuccess, onError);
